"use strict";
const angular = require("angular");
const uiRouter = require("angular-ui-router");

import alasql from "alasql";
import filter from "core-js/fn/array/filter";
import routes from "./map.routes";
import uuid from "uuid";

export class MapComponent {
  /*@ngInject*/
  constructor($http, $scope, $location, $timeout,lookup, mapService, theme, dbFactory, db) {
    // Angular classes
    this.$http = $http;
    this.$location = $location;
    this.$scope = $scope;
    this.$timeout = $timeout;

    //Load services
    this.lookup = lookup;
    this.mapService = mapService;
    this.theme = theme;
    this.dbFactory = dbFactory;
    this.db = db;

    // Global Variables
    this.$scope.selectedRecords = [];
    this.$scope.removeRecords = [];
    this.$scope.addRecords = [];
    this.$scope.GreenToggle = true;
    this.$scope.YellowToggle = true;
    this.$scope.RedToggle = true;
    this.$scope.listToggle = true;
    this.$scope.PinkToggle = true;
    this.$scope.OrangeToggle = true;
    this.$scope.BlueToggle = true;
    this.$scope.GrayToggle = true;
    this.$scope.filterLength = 0;
    this.$scope.actionsLength = 0;
    this.$scope.filterParcels = [];
    this.$scope.selectedParcels = [];
    this.$scope.myListParcels = [];
    this.$scope.user = {};

    this.$scope.addSitesList = [];

    this.$scope.zoomSpinner = false;

    
  }

  $onInit() {
    if (this.$location.search().parcel_id) {
      console.log(this.$location.search());
      this.$scope.dataParcel_id = this.$location.search().parcel_id;
    }

    // Get category layers and colors [Lookup Service]
    this.$scope.hessCategoryLayers = this.lookup.getHessCategoryLayers();

    //Get list of toggle map layers [Map Service]
    this.$scope.mapLayers = this.mapService.getMapLayers();

    //Load theme functions
    this.theme.initTheme();

  
    // Activate Multiple Selects 
    // $('#regionalZoneSelect').selectpicker();



    // Get list of regional zoning codes 
    this.$scope.zn_regional_codes = this.lookup.getRegionalCodes();
    // console.log(this.$scope.zn_regional_codes);

    //  Activate the Tooltips
    $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();

    // checking geojson layers
    // this.$http
    //   .get("/api/data/spatial/tcac")
    //   .then((response) => {
    //     this.$scope.tcacGeojson = response.data;
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    /**
     * API call to get user Organization info. Resolves promise synchronously from logged in user query, and then queries organization info. Pulled from Sql Server
     * param: Organization_ID (from logged in user)
     */
    if(this.db.getUser().length === 0){
      this.$http
      .get("/api/users/general")
      .then((response) => {
        console.log(response);
        this.$scope.user = response.data[0];
        this.$scope.role = this.$scope.user.role;
        this.$scope.city = response.data[0].Organization_Name;
        this.db.setUser(response.data[0]);
        console.log(this.$scope.city);
        if(this.$scope.role !== "jurisdiction"){
          this.getJurisdictions();
        }
        //Load Map and Hess Summary with a 2 second delay
        this.loadMap(this.$scope.city);
        
      })
      .catch((err) => {
        console.log(err);
      });
    } else {
      this.$scope.user = this.db.getUser();
      this.$scope.role = this.$scope.user.role;
      if(this.$scope.role !== "jurisdiction"){
        this.getJurisdictions();
      }
      console.log("the user service: ", this.db.getUser());
      this.$scope.city = this.$scope.user.Organization_Name;
        //Load Map and Hess Summary with a 2 second delay
        this.loadMap(this.$scope.city);
    }
    


  }

  //Collapse or show tabs based on selection
  // manageTabs(type) {
  //   if (type === "isScreened") {
  //     $("#planningActivitiesLayerCollapse").removeClass("show");
  //     $("#siteConstraintsCollapse").removeClass("show");
  //   }

  //   if (type === "isPlanning") {
  //     $("#screenedLayersCollapse").removeClass("show");
  //     $("#siteConstraintsCollapse").removeClass("show");
  //   }

  //   if (type === "isConstraints") {
  //     $("#planningActivitiesLayerCollapse").removeClass("show");
  //     $("#screenedLayersCollapse").removeClass("show");
  //   }
  // }

  loadMap(city) {
    console.log('running load map');
    var $scope = this.$scope;
    var $http = this.$http;
    var $location = this.$location;
    // var city = this.$scope.city;
    var updateInfoBox = this.updateInfoBox;
    var dbFactory = this.dbFactory;
    this.$scope.toggleMapLayer = this.toggleMapLayer;
    this.$scope.selectedRecords = [];
    var selectedRecords = [];
    var addSitesList = [];
    var listRecords = [];
    var mapService = this.mapService;

    this.$scope.removeRecords = [];
    var removeRecords = [];

    this.$scope.addRecords = [];
    var addRecords = [];
    var rowSelectedCollection = [];

    // define map
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNranVpYWNqeTFtMHEyeXRjdjFnN2lldTUifQ.09JACeDB27_PEaebVWA9rA";
    this.map = new mapboxgl.Map({
      container: "map", // container id
      style: "mapbox://styles/mapbox/light-v10", // stylesheet location
      zoom: 9,
      center: [-122.275051, 37.796966], //Set center based on geojson feature
    });

    this.map.addControl(
      new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,

        // limit results to US
        countries: "us",

        // further limit results to the geographic bounds representing the region of
        // California
        // bbox: [139.965, -38.03, 155.258, -27.839],

        // apply a client side filter to further limit results to those strictly within
        // the California region
        filter: function (item) {
          // returns true if item contains California region
          return item.context
            .map(function (i) {
              // id is in the form {index}.{id} per https://github.com/mapbox/carmen/blob/master/carmen-geojson.md
              // this example attempts to find the `region` named `California`
              return (
                i.id.split(".").shift() === "region" && i.text === "California"
              );
            })
            .reduce(function (acc, cur) {
              return acc || cur;
            });
        },
        mapboxgl: mapboxgl,
      })
    );

    // Add zoom and rotation controls to the map.
    this.map.addControl(new mapboxgl.NavigationControl());

    var loadHessLayers = this.loadHessLayers;
    var toggleMapLayer = this.toggleMapLayer;
    var zoomToSiteFromParams = this.zoomToSiteFromParams;
    var addDataLayer = this.addDataLayer;
    var openSiteEditModalMoreInfo = this.openSiteEditModalMoreInfo;

    this.map.on("load", function (map) {
      // console.log(map);
      //    Add Parcels Source
      map.target.addSource("parcelsSource", {
        type: "vector",
        //url: "mapbox://mtc-basis.cd90r7zz", //Parcel Atlas (updated December 9 2020)
        url: "mapbox://mtc-basis.5t29n8mv", //Parcel Atlas (updated September 20 2021) 
      });
      //Add jurisdiction boundary source
      map.target.addSource("jurisdictionBoundarySource", {
        type: "geojson",
        data: placesGeoJSON,
      });

    

     

      map.target.addLayer({
        id: "parcels",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        paint: {
          "fill-outline-color": "black",
          "fill-color": "white",
          "fill-opacity": 0.4,
        },
        filter: ["in", "jurisdiction", $scope.city],
      });

      //Add Hess Layers
      $scope.hessCategoryLayers.forEach((layer) => {
        if(layer.name === 'List'){
          console.log("added list layer");
        }
        map.target.addLayer({
          id: layer.name + "Layer",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "pa_v24d",
          paint: {
            "fill-outline-color": "black",
            "fill-color": layer.color,
            "fill-opacity": 0.7,
          },
          filter: ["in", "county", ""],
        });
      });

      // Add my sites 
      map.target.addLayer({
        id: "ListLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        paint: {
          "fill-outline-color": "black",
          "fill-color": "#824086",
          "fill-opacity": 0.7,
        },
        filter: ["in", "county", ""],
      });

    

      //Jurisdiction Layer

      if (!map.target.getLayer("jurisdiction-boundary")) {
        map.target.addLayer({
          id: "jurisdiction-boundary",
          type: "line",
          source: "jurisdictionBoundarySource",
          paint: {
            "line-color": "black",
            "line-width": 2,
          },
          filter: ["in", "NAME", ""],
        });
      }

      //Selected Parcels
      if (!map.target.getLayer("parcels-highlighted")) {
        map.target.addLayer({
          id: "parcels-highlighted",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "pa_v24d",
          paint: {
            "fill-outline-color": "darkgray",
            "fill-color": "#00fffa",
            "fill-opacity": 0.75,
          },
          filter: ["in", "parcel_id", ""],
        }); // Place polygon under these labels.
      }
      

      // Map Layer Toggle
      var layerList = document.getElementById("menu");
      var inputs = layerList.getElementsByTagName("input");
      // console.log(inputs);

      //Add data layers once style has loaded
      map.target.on("style.load", function () {
        // Triggered when `setStyle` is called.
        // add data layers to map
        addDataLayer($scope, mapService, map.target);
      });

      function switchLayer(layer) {
        // console.log(map);
        var layerId = layer.target.id;
        map.target.setStyle("mapbox://styles/mapbox/" + layerId);
      }

      for (var i = 0; i < inputs.length; i++) {
        inputs[i].onclick = switchLayer;
      }
      //End map layer toggle

      //Zoom map to jurisdiction currently logged in
      var zoomToFeature = _.filter(placesGeoJSON.features, function (item) {
        return item.properties.NAME === city;
      });

      var bbox = turf.extent(zoomToFeature[0].geometry);
      map.target.fitBounds(bbox, {
        padding: -150,
      });

      // When a click event occurs on a feature in the states layer, open a popup at the
      // location of the click, with description HTML from its properties.
      map.target.on("click", "parcels", function (e) {
        // $('.mapboxgl-popup').remove();
        var coordinates = e.lngLat;
        console.log("325: coordinates", coordinates);

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // set bbox as 5px reactangle area around clicked point
        var bbox = [
          [e.point.x - 5, e.point.y - 5],
          [e.point.x + 5, e.point.y + 5],
        ];
        var features = map.target.queryRenderedFeatures(bbox, {
          layers: ["parcels"],
        });
        // console.log(features);

        selectedRecords = $scope.selectedRecords;
        removeRecords = $scope.removeRecords;
        addRecords = $scope.addRecords;
        addSitesList = $scope.addSitesList;
        listRecords = $scope.listRecords;
        rowSelectedCollection = $scope.rowSelectedCollection;
        // updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, coordinates, openSiteEditModalMoreInfo);

        var filter = features.reduce(
          function (memo, feature) {
            memo.push(feature.properties.parcel_id);

            var checkParcelId = feature.properties.parcel_id;
            var checkIndex = selectedRecords.indexOf(checkParcelId);
            var checkRemoveIndex = removeRecords.indexOf(checkParcelId);
            var checkAddIndex = addRecords.indexOf(checkParcelId);
            var checkListIndex = listRecords.indexOf(checkParcelId);

            if (checkIndex > -1) {
              // Remove record from selected map layer 
              selectedRecords.splice(checkIndex, 1);
              //Remove from variable being used for Redshift functions
              addSitesList = addSitesList.filter(data => data.parcel_id != checkParcelId);
              // Remove record from selected tab table 
              _.remove(rowSelectedCollection, {
                parcel_id: feature.properties.parcel_id,
              });
            } else {
              selectedRecords.push(feature.properties.parcel_id);
             
            }

            // if (checkAddIndex > -1) {
            //   addRecords.splice(checkAddIndex, 1);
            // } else if (checkAddIndex === -1 && checkListIndex === -1) {
            //   addRecords.push(feature.properties.parcel_id);
            // }

            if (checkRemoveIndex > -1) {
              $scope.removeRecords.splice(checkRemoveIndex, 1);
            } else {
              $scope.listRecords.forEach((element) => {
                if (element === checkParcelId) {
                  $scope.removeRecords.push(checkParcelId);
                }
              });
            }
            // console.log($scope.removeRecords);

            return memo;
          },
          ["in", "parcel_id"]
        );
        $scope.selectedRecords = selectedRecords;
        $scope.addSitesList = addSitesList;
        //Update Update button with selected records count

        var array1 = ["in", "parcel_id"];
        var array2 = $scope.selectedRecords;

        var array3 = array1.concat(array2);

        // Set the filter to populate features into the layer.
        map.target.setFilter("parcels-highlighted", array3);
        map.target.selectedFilter = array3;

        $scope.selectedParcelId = e.features[0].properties.parcel_id;
        updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, openSiteEditModalMoreInfo);
      });

      //Add click events to hess layers
      $scope.hessCategoryLayers.forEach((element) => {
        map.target.on("click", element.name + "Layer", function (e) {
          // $('.mapboxgl-popup').remove();
          var coordinates = e.lngLat;
          // Ensure that if the map is zoomed out such that multiple
          // copies of the feature are visible, the popup appears
          // over the copy being pointed to.
          // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          // coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          // }
          updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, coordinates, openSiteEditModalMoreInfo);


        });
      });

      map.target.on("click", "ListLayer", function (e) {
        // $('.mapboxgl-popup').remove();
        updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, openSiteEditModalMoreInfo);
      });

      // Change the cursor to a pointer when the mouse is over the parcels layer.
      map.target.on("mouseenter", "parcels", function () {
        map.target.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      map.target.on("mouseleave", "parcels", function () {
        map.target.getCanvas().style.cursor = "";
      });

      // Change the cursor to a pointer when the mouse is over the list layer.
      map.target.on("mouseenter", "ListLayer", function () {
        map.target.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      map.target.on("mouseleave", "ListLayer", function () {
        map.target.getCanvas().style.cursor = "";
      });

      //Update cursor to pointer on mouseover for hess layers
      $scope.hessCategoryLayers.forEach((element) => {
        // Change the cursor to a pointer when the mouse is over the states layer.
        map.target.on("mouseenter", element.name + "Layer", function () {
          map.target.getCanvas().style.cursor = "pointer";
        });

        // Change it back to a pointer when it leaves.
        map.target.on("mouseleave", element.name + "Layer", function () {
          map.target.getCanvas().style.cursor = "";
        });
      });

      // Set global map variable based on local map variable settings
      $scope.map = map.target;

      //Load Hess Layers
      loadHessLayers($http, $scope);

      // Zoom to site if parameters present for parcel id
      zoomToSiteFromParams($scope.dataParcel_id, $scope, $http, $location);
    });

    
    this.loadHessSummary();
        
    // Get my list of parcels 
    this.getMyList();

    //Load zoning, gp and existing use codes
    this.loadAllCodes();
  
    // Load Enviro Summary 
    this.loadHessEnviroSummary();

    //Load Planning Summary
    this.loadHessPlanningSummary();
  }




  addDataLayer($scope, mapService, map) {
    // console.log($scope);
    //Function to manage toggling legend map layers [Map Service]
    mapService.updateHessToggles($scope);

    map.addSource("parcelsSource", {
      type: "vector",
      url: "mapbox://mtc-basis.5t29n8mv", //Parcel Atlas (updated September 20, 2021)

    });
    //Add jurisdiction boundary source
    map.addSource("jurisdictionBoundarySource", {
      type: "geojson",
      data: placesGeoJSON,
    });

    if ($scope.array3) {
      map.addLayer({
        id: "parcels",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        paint: {
          "fill-outline-color": "black",
          "fill-color": "white",
          "fill-opacity": 0.4,
        },
        filter: $scope.array3,
      });
    } else {
      map.addLayer({
        id: "parcels",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        paint: {
          "fill-outline-color": "black",
          "fill-color": "white",
          "fill-opacity": 0.4,
        },
        filter: ["in", "jurisdiction", $scope.city],
      });
    }

    if ($scope.array3Red) {
      map.addLayer({
        id: "RedLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.RedVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#D60D3B",
          "fill-opacity": 0.7,
        },
        filter: $scope.array3Red,
      });
    } else {
      map.addLayer({
        id: "RedLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.RedVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#D60D3B",
          "fill-opacity": 0.7,
        },
        filter: map.RedFilter,
      });
    }

    if ($scope.array3Yellow) {
      map.addLayer({
        id: "YellowLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.YellowVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#ffb73b",
          "fill-opacity": 0.7,
        },
        filter: $scope.array3Yellow,
      });
    } else {
      map.addLayer({
        id: "YellowLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.YellowVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#ffb73b",
          "fill-opacity": 0.7,
        },
        filter: map.YellowFilter,
      });
    }

    if ($scope.array3Green) {
      map.addLayer({
        id: "GreenLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.GreenVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#199694",
          "fill-opacity": 0.7,
        },
        filter: $scope.array3Green,
      });
    } else {
      map.addLayer({
        id: "GreenLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.GreenVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#199694",
          "fill-opacity": 0.7,
        },
        filter: map.GreenFilter,
      });
    }


    if ($scope.array3Orange) {
      map.addLayer({
        id: "OrangeLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.OrangeVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#ff6d12",
          "fill-opacity": 0.7,
        },
        filter: $scope.array3Orange,
      });
    } else {
      map.addLayer({
        id: "OrangeLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.OrangeVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#ff6d12",
          "fill-opacity": 0.7,
        },
        filter: map.OrangeFilter,
      });
    }


    if ($scope.array3Pink) {
      map.addLayer({
        id: "PinkLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.PinkVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#ff57bc",
          "fill-opacity": 0.7,
        },
        filter: $scope.array3Pink,
      });
    } else {
      map.addLayer({
        id: "PinkLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.PinkVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#ff57bc",
          "fill-opacity": 0.7,
        },
        filter: map.PinkFilter,
      });
    }


    if ($scope.array3Blue) {
      map.addLayer({
        id: "BlueLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.BlueVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#0C7CBA",
          "fill-opacity": 0.7,
        },
        filter: $scope.array3Blue,
      });
    } else {
      map.addLayer({
        id: "BlueLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.BlueVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#0C7CBA",
          "fill-opacity": 0.7,
        },
        filter: map.BlueFilter,
      });
    }

    if ($scope.array3Gray) {
      map.addLayer({
        id: "GrayLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.GrayVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "gray",
          "fill-opacity": 0.7,
        },
        filter: $scope.array3Gray,
      });
    } else {
      map.addLayer({
        id: "GrayLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.GrayVisible,
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "gray",
          "fill-opacity": 0.7,
        },
        filter: map.GrayFilter,
      });
    }

    if ($scope.array3List) {
      map.addLayer({
        id: "ListLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.listVisible,
        paint: {
          "fill-outline-color": "#824086",
          "fill-color": "#824086",
          "fill-opacity": 0.7,
        },
        filter: $scope.array3List,
      });
    }
    else {
      map.addLayer({
        id: "ListLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        layout: $scope.listVisible,
        paint: {
          "fill-outline-color": "#824086",
          "fill-color": "#824086",
          "fill-opacity": 0.7,
        },
        filter: map.ListFilter,
      });
    }

    

    //Jurisdiction Layer

    if (!map.getLayer("jurisdiction-boundary")) {
      map.addLayer({
        id: "jurisdiction-boundary",
        type: "line",
        source: "jurisdictionBoundarySource",
        paint: {
          "line-color": "black",
          "line-width": 2,
        },
        filter: ["in", "NAME", ""],
      });
    }

    console.log(map.selectedFilter);
    if (!map.selectedFilter) {
      map.selectedFilter = ["in", "parcel_id", ""];
    }
    //Selected Parcels
    map.addLayer({
      id: "parcels-highlighted",
      type: "fill",
      source: "parcelsSource",
      "source-layer": "pa_v24d",
      paint: {
        "fill-outline-color": "darkgray",
        "fill-color": "#00fffa",
        "fill-opacity": 0.75,
      },
      filter: map.selectedFilter,
    }); // Place polygon under these labels.

    if (map.layerName) {
      var toggleStatus = map.layerName + "Toggle";
      for (let index = 0; index < $scope.mapLayers.length; index++) {
        const element = $scope.mapLayers[index];
        if (element.name === map.layerName) {
          if ($scope.map.getSource(element.source)) {
            visibility = $scope.map.getLayoutProperty(element.name, "visibility");
            // toggle layer visibility by changing the layout object's visibility property
            if (visibility === "visible") {
              $scope.map.setLayoutProperty(element.name, "visibility", "none");
              $scope.visibleLayer = element.name;
              this.className = "";
            } else if (toggleStatus == false) {
              $scope.map.setLayoutProperty(element.name, "visibility", "none");
              $scope.visibleLayer = element.name;
              this.className = "";
            } else {
              this.className = "active";
              $scope.map.setLayoutProperty(element.name, "visibility", "visible");
            }
            $scope.loadingDiv = false;
          } else {
            $http
              .get(element.url)
              .then((response) => {
                $scope.map.addSource(element.source, {
                  type: "geojson",
                  data: response.data,
                });
                var paint = {};
                if(element.type === 'mapbox'){
                  paint =  {
                    "fill-outline-color": "white",
                    "fill-color": element.fillColor,
                    "fill-opacity": 0.4,
                  } 
                } else if(element.type === 'socrata'){
                    paint = element.paint;
                }

                $scope.map.addLayer({
                  id: element.name,
                  type: "fill",
                  source: element.source,
                  paint: paint,
                }, "parcels");

                if (!$scope[toggleStatus]) {
                  $scope.map.setLayoutProperty(element.name, "visibility", "none");
                } else {
                  $scope.map.setLayoutProperty(
                    element.name,
                    "visibility",
                    "visible"
                  );
                }
                $scope.loadingDiv = false;
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          if ($scope.map.getSource(element.source)) {
            $scope.map.setLayoutProperty(element.name, "visibility", "none");
            $scope[element.name + "Toggle"] = false;
          }
        }
      }
    }
  }

  updateInfoBox(parcel_id, $http, $scope, dbFactory, coordinates, openSiteEditModalMoreInfo) {
console.log("line 863: ", coordinates);


    var basicInfoPopup;
    // console.log(openSiteEditModalMoreInfo);
    $("#layersTabNav").removeClass("active");
    $("#myListTabNav").removeClass("active");
    $("#filtersTabNav").removeClass("active");
    $("#adminTabNav").removeClass("active");
    $("#selectedTabNav").addClass("active");

    $("#layersTabPanel").removeClass("active");
    $("#myListTabPanel").removeClass("active");
    $("#filtersTabPanel").removeClass("active");
    $("#adminTabPanel").removeClass("active");
    

    $("#selectedTabPanel").addClass("active");
    // console.log(coordinates);


    dbFactory
      .getParcelDetail(parcel_id)
      .then((response) => {
        console.log("dbFactory: ", response.data[0]);
        var feature = response.data[0];
        $scope.feature = response.data[0];
        var addRecordToSelected = alasql('select * from ? where parcel_id = "' + $scope.feature.parcel_id + '"', [$scope.selectedParcels]);

        // If record has not already been added to Selection, add it 
        if (addRecordToSelected.length === 0) {
          $scope.selectedParcels.push(response.data[0]);
          $scope.rowSelectedCollection = _.uniqBy($scope.selectedParcels, "parcel_id");
        }

        // console.log($scope.rowSelectedCollection);
        var parcel_id = feature.parcel_id;

        console.log("895: coordinates ", coordinates);
        console.log(Array.isArray(coordinates));
        // if(basicInfoPopup){
        //   basicInfoPopup.remove()
        // } else {
        //   basicInfoPopup = new mapboxgl.Popup()
        //   .setLngLat(coordinates)
        //   .setHTML('<h5>Basic Information</h5><table class="table"><tr><td>Jurisdiction:</td><td>' + feature.jurisdiction + '</td></tr><tr><td>APN:</td><td>' + feature.apn + '</td></tr><tr><td>Address:</td><td>' + feature.address + '</td></tr><tr><td>5 Digit Zip Code:</td><td>' + feature.zip_code + '</td></tr><tr><td><button id="moreInfoBtn" class="btn btn-default disabled">More Info</button></td></tr></table>')
        //   .addTo($scope.map);
        // }

        // setTimeout(function () {
        //   $('#moreInfoBtn').removeClass('btn-default').removeClass('disabled').addClass('btn-primary');
        //   // console.log($('#moreInfoBtn'));
        //   $('#moreInfoBtn').on('click', function () {
        //     openSiteEditModalMoreInfo(parcel_id, $http, $scope, dbFactory);
        //   })
        // }, 300);

      })
      .catch((err) => {
        console.log(err);
      });
  }

  loadAllCodes(){
    this.$scope.zn_codes = [];
    this.$scope.gp_codes = [];
    this.$scope.use_codes = [];
    //Get list of zoning codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getZoningCodes().length > 0) {
    //   this.$scope.zn_codes = this.lookup.getZoningCodes();
    // } else {
      this.$http
        .get("/api/data/parcels/zncodes/" + this.$scope.city)
        .then((response) => {
          // console.log("zoning codes: ", response.data);
          this.$scope.zn_codes = response.data;
          //Set zoning codes in lookup service
          this.lookup.setZoningCodes(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    // }

    //Get list of GP codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getGPCodes().length > 0) {
    //   this.$scope.gp_codes = this.lookup.getGPCodes();
    // } else {
      this.$http
        .get("/api/data/parcels/gpcodes/" + this.$scope.city)
        .then((response) => {
          this.$scope.gp_codes = response.data;
          console.log('gp_codes: ', this.$scope.gp_codes);
          //Set GP codes in lookup service
          this.lookup.setGPCodes(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    // }

    //Get list of use codes
      this.$http
        .get("/api/data/hess/parcel/uses/" + this.$scope.city)
        .then((response) => {
          // console.log("use codes: ", response.data);
          this.$scope.use_codes = response.data;
          this.lookup.setUseCodes(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
  
  }

  loadHessLayers($http, $scope) {
    $scope.hessCategoryLayers.forEach((element) => {
      var filter = element.name + 'Filter';
      // console.log(filter);
      $http
        .get("/api/data/hess/layers/" + $scope.city + "/" + element.name)
        .then((response) => {
          // console.log(response.data[0]);
          var records = _.map(response.data, "parcel_id");

          //Set up filter for each layer
          var array1 = ["in", "parcel_id"];
          var array3 = array1.concat(records);
          // console.log(array3);

          // Set the filter to populate features into the layer.
          $scope.map.setFilter(element.name + "Layer", array3);
          $scope.map[filter] = array3;
        })
        .catch((err) => {
          console.log(err);
        });
    });

    $http
      .get("/api/data/hess/layers/list/ids/" + $scope.city)
      .then((response) => {
        // console.log("List: ", response.data);
        $scope.listRecords = _.map(response.data, "parcel_id");
        // $scope.listRecords = [];
        var listRecords = $scope.listRecords;
        // console.log(listRecords);

        var array1 = ["in", "parcel_id"];
        var array3 = array1.concat(listRecords);

        // Set the filter to populate features into the layer.
        $scope.map.setFilter("ListLayer", array3);
        $scope.map.ListFilter = array3;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  loadHessSummary() {
    if(this.lookup.getHessSummary().hasOwnProperty('Blue')){
      this.$scope.hessSummary = this.lookup.getHessSummary();
    } else {
      this.$http
      .get("/api/data/hess/" + this.$scope.city)
      .then((response) => {
        // console.log(response.data);
        this.$scope.hessSummaryTotal = {};
        this.$scope.hessCategoryLayers.forEach(element => {
          // console.log(element);
          var name = element.name;
          var summary;
          if (
            _.filter(response.data, {
              hess_color: name,
            })[0]
          ) {
            summary = _.filter(response.data, {
              hess_color: name,
            })[0].count_hess_color;
          } else {
            summary = 0;
          }
          this.$scope.hessSummaryTotal[name] = summary;

        });

        // console.log(this.$scope.hessSummaryTotal);

        this.$scope.hessSummary = this.$scope.hessSummaryTotal;
        this.lookup.setHessSummary(this.$scope.hessSummary);
      })
      .catch((err) => {
        console.log(err);
      });
    }
   
  }

  // Environmental Constraints Summary
  loadHessEnviroSummary() {
   if(this.lookup.getHessEnviroSummary().hasOwnProperty('in_cpad')){
    this.$scope.hessEnviroSummary = this.lookup.getHessEnviroSummary();
   } else {
    this.$scope.hessEnviroSummary = {
      in_cpad: 0,
      in_floodplain: 0,
      in_landslide: 0,
      in_liquefact: 0,
      in_riparian: 0,
      in_seismic: 0,
      in_habitat: 0,
      in_slr36: 0,
      in_slr77: 0,
      // in_liquefaction: 0,
      // The following value i snot currently a boolean
      fire_haz_class: ''
    };

    for (const key in this.$scope.hessEnviroSummary) {
      // console.log(key);
      this.$http
        .get("/api/data/hess/enviro/" + key)
        .then(response => {
          if (response.data[0]) {
            var key_count = key + '_count';
            this.$scope.hessEnviroSummary[key] = response.data[0][key_count];
            // console.log(this.$scope.hessEnviroSummary);
          }

        })
        .catch(err => {
          console.log(err);
        })
    }

    this.lookup.setHessEnviroSummary(this.$scope.hessEnviroSummary);
   }

  }

  // Planning Considerations Summary
  loadHessPlanningSummary() {
   if(this.lookup.getHessPlanningSummary().hasOwnProperty('in_pda')){
    this.$scope.hessPlanningSummary = this.lookup.getHessPlanningSummary();
   } else {
    this.$scope.hessPlanningSummary = {
      in_pda: 0,
      in_tpa: 0,
      in_ppa: 0,
      in_urban_area: 0,
      in_hra: 0,
      in_gg: 0
    };

    for (const key in this.$scope.hessPlanningSummary) {
      // console.log(key);
      this.$http
        .get("/api/data/hess/planning/" + key)
        .then(response => {
          // console.log(response.data[0]);
          if (response.data[0]) {
            var key_count = key + '_count';
            this.$scope.hessPlanningSummary[key] = response.data[0][key_count];
            // console.log(this.$scope.hessPlanningSummary);
          }

        })
        .catch(err => {
          console.log(err);
        })
    }

    this.lookup.setHessPlanningSummary(this.$scope.hessPlanningSummary);
   }
  }


  //Start clear selected function
  clearSelected() {
    // $('.mapboxgl-popup').remove();
    this.$scope.selectedRecords = [];
    this.$scope.removeRecords = [];
    this.$scope.addRecords = [];
    this.$scope.selectedParcels = [];
    this.$scope.rowSelectedCollection = [];
    var array1 = ["in", "parcel_id", ""];
    this.$scope.parcelSummary = null;
    
    this.$scope.map.selectedFilter = ["in", "parcel_id", ""];
    this.$scope.map.setFilter("parcels-highlighted", array1);
    
  }
  //End clear selected function

  // Start add to list function
  addSitesToList(parcel_id) {
    this.$scope.addToSitesSpinner = true;

    if (parcel_id) {
      console.log("there was a parcel id");
      this.$scope.addRecords.push(parcel_id);
    } else if (this.$scope.selectedRecords.length > 0) {
      this.$scope.selectedRecords.forEach(element => {
        console.log(element);
        console.log(typeof this.$scope.addRecords[element]);
        if (typeof this.$scope.addRecords[element] === 'undefined') {
          this.$scope.addRecords.push(element);
        }
      });
    }
    console.log(this.$scope.addRecords);
    this.$http
      .post("/api/data/hess/parcel/list/add", this.$scope.addRecords)
      .then((response) => {
        this.$scope.addRecords.forEach((element) => {
          this.$scope.listRecords.push(element);
          console.log(this.$scope.listRecords);

          var array1 = ["in", "parcel_id"];
          var array3 = array1.concat(this.$scope.listRecords);

          // Set the filter to populate features into the layer.
          this.$scope.map.setFilter("ListLayer", array3);
          this.clearSelected();

        });

        this.$scope.selectedRecords = [];
        this.$scope.addRecords = [];
        // this.$scope.listRecords = [];
        this.$scope.addToSitesSpinner = false;
        this.getMyList();
      })
      .catch((err) => {
        console.log(err);
        this.$scope.addToSitesSpinner = false;
      });
  }

  // Start remove from list function
  removeSitesFromList(parcel_id) {
    this.$scope.removeSitesSpinner = false;
    var checkIndex;
    this.$scope.removeRecords = [];

    //If parcel is being deleted from my list tab, remove it both from local array and socrata table
    if (this.$scope.myListParcels.length > 0 && parcel_id) {
      this.$scope.removeRecords.push(parcel_id);
      _.remove(this.$scope.myListParcel, {
        parcel_id: parcel_id,
      });

      _.remove(this.$scope.rowListCollection, {
        parcel_id: parcel_id,
      });
    }

    this.$http
      .post("/api/data/hess/parcel/list/remove", this.$scope.removeRecords)
      .then((response) => {
        var checkIndex;
        // console.log("the remove records: ", this.$scope.removeRecords);

        this.$scope.removeRecords.forEach(element => {
          checkIndex = this.$scope.listRecords.indexOf(element);
          // console.log(checkIndex);
          this.$scope.listRecords.splice(checkIndex, 1);
          // console.log("the list of records: ", this.$scope.listRecords);

          var array1 = ["in", "parcel_id"];
          var array3 = array1.concat(this.$scope.listRecords);
          // console.log(array3);

          // Set the filter to populate features into the layer.
          this.$scope.map.setFilter("ListLayer", array3);
          this.clearSelected();
        });

        this.$scope.selectedRecords = [];
        this.$scope.removeRecords = [];
        this.$scope.removeSitesSpinner = false;
      })
      .catch((err) => {
        console.log(err);
        this.$scope.removeSitesSpinner = false;
      });
  }
  // End remove from list function

  // Start update parcel function
  updateSiteData() {
    var data = this.$scope.hessParcel;

    console.log(data);
    //Add use code description based on use code
    if (data.existing_use_code) {
      data.existing_use_description = _.filter(this.$scope.use_codes, {
        existing_use_code: data.existing_use_code,
      })[0].existing_use_description;
    }
    console.log("use codes: ", data.existing_use_code);
    console.log(data.existing_use_description);

    // console.log(data);

    //test hess category calculation
    this.$http
      .post("/api/data/hess/update", data)
      .then((response) => {
        // console.log("283. ", response);
        var hess_category = response.data.hess_category;

        //Find parcel id being updated in the hess layers, and update layers accordingly
        var posRed = this.$scope.map.RedFilter.indexOf(response.data.parcel_id);
        var posYellow = this.$scope.map.YellowFilter.indexOf(response.data.parcel_id);
        var posGreen = this.$scope.map.GreenFilter.indexOf(response.data.parcel_id);
        var posPink = this.$scope.map.PinkFilter.indexOf(response.data.parcel_id);
        var posOrange = this.$scope.map.OrangeFilter.indexOf(response.data.parcel_id);
        var posBlue = this.$scope.map.BlueFilter.indexOf(response.data.parcel_id);
        var posGray = this.$scope.map.GrayFilter.indexOf(response.data.parcel_id);


        console.log(posRed);
        console.log(posYellow);
        console.log(posGreen);
        console.log(posPink);
        console.log(posBlue);
        console.log(posOrange);
        console.log(posGray);

        // Red 
        if (hess_category === "Environmentally Constrained Sites" && posRed === -1) {
          // console.log('it should be red');
          this.$scope.map.RedFilter.push(response.data.parcel_id);
         
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }

          if (posGray > -1) {
            this.$scope.map.BlueFilter.splice(posGray, 1);
          }
          
        }


        // Yellow 
        if (hess_category === "Non-Vacant Residential Sites" && posYellow === -1) {
          // console.log('it should be yellow');
          this.$scope.map.YellowFilter.push(response.data.parcel_id);
        
          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
          
        }

        // Green 
        if (hess_category === "Vacant Non-Residential Sites" && posGreen === -1) {
          // console.log('it should be green');
          this.$scope.map.GreenFilter.push(response.data.parcel_id);
          
          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
        }

        // Pink 
        if (hess_category === "Public Sites" && posPink === -1) {
          // console.log('it should be pink');
          this.$scope.map.PinkFilter.push(response.data.parcel_id);

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          
        }

        // Blue 
        if (hess_category === "Non-Vacant Non-Residential Sites" && posBlue === -1) {
          // console.log('it should be blue');
          this.$scope.map.BlueFilter.push(response.data.parcel_id);

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
          
        }

        // Orange 
        if (hess_category === "Vacant Residential Sites" && posOrange === -1) {
          // console.log('it should be orange');
          this.$scope.map.OrangeFilter.push(response.data.parcel_id);

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
          
        }

        // Unclassified 
        if (hess_category === "Unclassified Sites" && posGray === -1) {
          console.log('it should be unclassified');
          this.$scope.map.GrayFilter.push(response.data.parcel_id);

          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
        }

         // Parks/Row Sites 
         if (hess_category === "Parks/ROW Sites") {
          console.log('it should be park row');
          
          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }

          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
        }



        //Update map layers to show edit updates
        this.$scope.map.setFilter("GreenLayer", this.$scope.map.GreenFilter);
        this.$scope.map.setFilter("YellowLayer", this.$scope.map.YellowFilter);
        this.$scope.map.setFilter("RedLayer", this.$scope.map.RedFilter);
        this.$scope.map.setFilter("OrangeLayer", this.$scope.map.OrangeFilter);
        this.$scope.map.setFilter("BlueLayer", this.$scope.map.BlueFilter);
        this.$scope.map.setFilter("PinkLayer", this.$scope.map.PinkFilter);
        this.$scope.map.setFilter("GrayLayer", this.$scope.map.GrayFilter);

        // Update basic parcel info box
        this.$scope.feature.address = response.data.address;
        this.$scope.feature.zip_code = response.data.zip_code;
        this.$scope.feature.apn = response.data.apn;

        this.clearSelected();
        $("#siteSelectionModal").modal("hide");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // End update parcel function

  //Update zoning information when zoning code is selected
  updateZnCodeInfo() {
   
    this.$scope.zn_codes.forEach(element => {
      if (element.zn_recid === this.$scope.hessParcel.zn_recid) {
        console.log(element);
        this.$scope.hessParcel.zn_code = element.zn_code;
        this.$scope.hessParcel.zn_description = element.zn_description;
        this.$scope.hessParcel.zn_regional_code = element.zn_regional_code;
        this.$scope.hessParcel.zn_regional_description = element.zn_regional_description;
        this.$scope.hessParcel.zn_max_dua = element.zn_max_dua;
        this.$scope.hessParcel.zn_min_dua = element.zn_min_dua;
        this.$scope.hessParcel.zn_max_height = element.zn_max_height;

        this.$scope.hessParcel.zn_units_per_lot = element.zn_units_per_lot;
        this.$scope.hessParcel.zn_max_far = element.zn_max_far;
        this.$scope.hessParcel.zn_min_lot_sqft = element.zn_min_lot_sqft;
        this.$scope.hessParcel.zn_lot_coverage_pct = element.zn_lot_coverage_pct;

        //Calculate max capacity
        if (parseFloat(element.zn_max_dua) && parseFloat(this.$scope.hessParcel.acres)) {
          this.$scope.hessParcel.max_capacity = (parseFloat(element.zn_max_dua) * parseFloat(this.$scope.hessParcel.acres)).toFixed(2);
        } else {
          this.$scope.hessParcel.max_capacity = null;
        }
      }
    });



    // console.log(this.$scope.hessParcel.parcel_id);



  }

  //Update GP information when gp code is selected
  updateGPCodeInfo() {
    this.$scope.gp_codes.forEach(element => {
      console.log(element);
      console.log(this.$scope.hessParcel.gp_recid);
      if (element.gp_recid === this.$scope.hessParcel.gp_recid) {
        this.$scope.hessParcel.gp_description = element.gp_description;
        this.$scope.hessParcel.gp_code = element.gp_code;

      }
    });
  }

  toggleMapLayer(layerName) {
    var visibility;
    this.$scope.loadingDiv = true;
    var type;

    for (let index = 0; index < this.$scope.mapLayers.length; index++) {
      const element = this.$scope.mapLayers[index];
      if (element.name === layerName) {
        if (this.$scope.map.getSource(element.source)) {
          visibility = this.$scope.map.getLayoutProperty(
            element.name,
            "visibility"
          );
          // toggle layer visibility by changing the layout object's visibility property
          if (visibility === "visible") {
            this.$scope.map.setLayoutProperty(
              element.name,
              "visibility",
              "none"
            );
            this.$scope.visibleLayer = element.name;
            this.className = "";
          } else {
            this.className = "active";
            this.$scope.map.setLayoutProperty(
              element.name,
              "visibility",
              "visible"
            );
          }
          this.$scope.loadingDiv = false;
        } else {
          console.log(element.url);
          this.$http
            .get(element.url)
            .then((response) => {
              // console.log(response.data);
              var layerData = response.data;
              console.log(layerData);
              var paint = {};
              if(element.type === 'mapbox'){
                paint =  {
                  "fill-outline-color": "white",
                  "fill-color": element.fillColor,
                  "fill-opacity": 0.4,
                } 

                this.$scope.map.addSource(element.source, {
                  type: layerData.sources.composite.type,
                  url: layerData.sources.composite.url, //Parcel Atlas (updated September 15 2021)
                });

              } else if(element.type === 'socrata'){
                if(element.style === 'numerical' || element.style === 'circle'){
                  console.log(element.property);
                  layerData.features.forEach(data => {
                    data.properties[element.property] = parseFloat(data.properties[element.property]);
                  });
                }
                  paint = element.paint;
                  this.$scope.map.addSource(element.source, {
                    type: "geojson",
                    data: layerData
                  });
              }

             

              //Add filter for jurisdiction
             if(element.type === 'mapbox'){
              if(layerData.layers[0].filter){
                console.log(layerData.layers[0].filter);
                this.$scope.map.addLayer({
                  id: element.name,
                  type: layerData.layers[0].type,
                  source: element.source,
                  "source-layer": layerData.layers[0]["source-layer"],
                  paint: layerData.layers[0].paint,
                  filter: layerData.layers[0].filter,
                });
              } else {
                this.$scope.map.addLayer({
                  id: element.name,
                  type: layerData.layers[0].type,
                  source: element.source,
                  "source-layer": layerData.layers[0]["source-layer"],
                  paint: layerData.layers[0].paint
                });
              }
             } else if(element.type === 'socrata'){
               if(element.style === 'circle'){
                type = 'circle';
               } else {
                type = 'fill'
               }
              this.$scope.map.addLayer({
                id: element.name,
                type: type,
                source: element.source,
                'paint': element.paint
              
              },'parcels');
              //  console.log(element.paint);
              // this.$scope.map.addLayer({
              //   id: element.name,
              //   type: 'fill',
              //   source: element.source,
              //   'paint': {
              //     'fill-color': {
              //         property: 'hcv_pct',
              //         stops: [
              //             [0.2, 'lightgray'],
              //             [0.5, 'red'],
              //             [15.0, 'blue']
              //         ]
              //     }
               
              // });
             }
             

              this.$scope.map.setLayoutProperty(element.name, "visibility", "visible");

              // Add default opacity to 50% 
              if(element.name !== 'sphereofinfluenceLayer' && element.type === 'mapbox'){
                this.$scope.map.setPaintProperty(element.name, "fill-opacity", 0.5);
              }

              // Filter zoning and gp layers to only show data in jurisdiction 
              if (element.name === 'znLayer' || element.name === 'gpLayer') {
                this.$scope.map.setFilter(element.name, ["in", "jurisdiction", this.$scope.city]);
              }

              if (element.name === 'sphereofinfluenceLayer') {
                console.log(element.name);
                this.$scope.map.setFilter(element.name, [
                  "match",
                  [
                    "get",
                    "jurisdiction"
                  ],
                  [
                    this.$scope.city
                  ],
                  true,
                  false
                ]);
              }

              this.$scope.loadingDiv = false;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        if (this.$scope.map.getSource(element.source)) {
          this.$scope.map.setLayoutProperty(element.name, "visibility", "none");
          this.$scope[element.name + "Toggle"] = false;
          this.$scope.loadingDiv = false;
        }
      }
      this.$scope.loadingDiv = true;
    }

    //Unclassified Layer
    if (layerName === "GrayLayer") {
      // visibility = this.$scope.map.getLayoutProperty(layerName, 'visibility');
      console.log("the visibility: ", visibility);
      // toggle layer visibility by changing the layout object's visibility property
      if (this.$scope.GrayToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }

    //My list Layer
    if (layerName === "ListLayer") {
      // visibility = this.$scope.map.getLayoutProperty(layerName, 'visibility');
      console.log("the visibility: ", visibility);
      // toggle layer visibility by changing the layout object's visibility property
      if (this.$scope.listToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }

    //Green Layer
    if (layerName === "GreenLayer") {
      if (this.$scope.GreenToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }

    //Yellow Layer
    if (layerName === "YellowLayer") {
      if (this.$scope.YellowToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }

    //Red Layer
    if (layerName === "RedLayer") {
      if (this.$scope.RedToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }

    //Orange Layer
    if (layerName === "OrangeLayer") {
      if (this.$scope.OrangeToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }

    //Blue Layer
    if (layerName === "BlueLayer") {
      if (this.$scope.BlueToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }

    //Pink Layer
    if (layerName === "PinkLayer") {
      if (this.$scope.PinkToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }
  }

  //Update map using filters
  updateMap() {
    this.$scope.rowCollection = [];

    // Remove any false values from filter
    for (const key in this.$scope.filter) {
      if (this.$scope.filter.hasOwnProperty(key)) {
        if (this.$scope.filter[key] === false) {
          delete this.$scope.filter[key];
        }
      }
    }

    this.$scope.filterLength = Object.keys(this.$scope.filter).length;
    // console.log(this.$scope.filterLength);
    this.$scope.actionsLength = 0;
   
    this.$http
      .post("/api/data/hess/parcels/filter/all", this.$scope.filter)
      .then((response) => {
        // console.log("filtered records: ", response.data);
        this.$scope.rowCollection = response.data;
        this.$scope.filterParcels = _.map(response.data, "parcel_id");
        var filterKey, arrayKey, layerName;

        this.$scope.hessSummary = {};

        this.$scope.hessCategoryLayers.forEach(element => {
          console.log(element);
          filterKey = "filterParcels" + element.name;
          arrayKey = "array3" + element.name;
          layerName = element.name + 'Layer';

         
          if(element.name === 'List'){
            this.$scope.filterParcelsList = _.map(
              _.filter(response.data, {
                in_list: true,
              }),
              "parcel_id"
            );
          } else {
            this.$scope[filterKey] = _.map(
              _.filter(response.data, {
                hess_color: element.name,
              }),
              "parcel_id"
            );
          }

          //My Sites

          this.$scope.hessSummary[element.name] = this.$scope[filterKey].length;

          // Set map filters 
          this.$scope[arrayKey] = ["in", "parcel_id"].concat(this.$scope[filterKey]);

          // Update Map Layers with filter 
          this.$scope.map.setFilter(layerName, this.$scope[arrayKey]);

        });

        // Update base parcel layer 
        this.$scope.array3 = ["in", "parcel_id"].concat(this.$scope.filterParcels);
        this.$scope.map.setFilter("parcels", this.$scope.array3);

      })
      .catch((err) => {
        console.log(err);
      });

    // Close filters modal 
    $('#newfiltersModal').modal('hide');
  }

  //Clear filters
  clearFilters() {
    this.$scope.filter = {};
    this.$scope.filterParcels = [];
    this.$scope.filterLength = 0;
    this.$scope.actionsLength = 0;
   
    //Reset multi selects
    // $("#znRegionalCodeSelect").val('default');
    // $("#znRegionalCodeSelect").selectpicker("refresh");

    // $("#znCodeSelect").val('default');
    // $("#znCodeSelect").selectpicker("refresh");

    this.$scope.rowCollection = [];

    // Set the filter to populate features into the layer.
    this.$scope.map.setFilter("parcels", ["in", "jurisdiction", this.$scope.city]);
    this.$scope.map.setFilter("GreenLayer", this.$scope.map.GreenFilter);
    this.$scope.map.setFilter("YellowLayer", this.$scope.map.YellowFilter);
    this.$scope.map.setFilter("RedLayer", this.$scope.map.RedFilter);
    this.$scope.map.setFilter("BlueLayer", this.$scope.map.BlueFilter);
    this.$scope.map.setFilter("PinkLayer", this.$scope.map.PinkFilter);
    this.$scope.map.setFilter("OrangeLayer", this.$scope.map.OrangeFilter);
    this.$scope.map.setFilter("GrayLayer", this.$scope.map.GrayFilter);
    this.$scope.map.setFilter("ListLayer", this.$scope.map.ListFilter);
    // this.$scope.map.setFilter('zoomParcelLayer', ["in", "parcel_id", ""]);
    if (this.$scope.map.getSource("zoomParcelSource")) {
      this.$scope.map.removeLayer("zoomParcelLayer");
      this.$scope.map.removeSource("zoomParcelSource");
    }

    // Reset hess layer filters 
    this.$scope.array3Green = this.$scope.map.GreenFilter;
    this.$scope.array3Yellow = this.$scope.map.YellowFilter;
    this.$scope.array3Red = this.$scope.map.RedFilter;
    this.$scope.array3Blue = this.$scope.map.BlueFilter;
    this.$scope.array3Pink = this.$scope.map.PinkFilter;
    this.$scope.array3Orange = this.$scope.map.OrangeFilter;
    this.$scope.array3Gray = this.$scope.map.GrayFilter;
    this.$scope.array3List = this.$scope.map.ListFilter;

    this.$scope.hessSummary = this.$scope.hessSummaryTotal;
  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  openSiteEditModal(parcel_id) {
    this.$scope.parcel_id = parcel_id;
    //Open CRUD Modal
    if (parcel_id) {
      $("#siteSelectionModal").modal();

      this.dbFactory.getParcelDetail(parcel_id) //DB Factory function
        .then((response) => {
          var hess_category_desc;
          
          var allows_residential = response.data[0].allows_residential;
          if(allows_residential === "1.0"){
            allows_residential = "1";
          }
          if(allows_residential === "0.0"){
            allows_residential = "0";
          }

          response.data[0].allows_residential = allows_residential;
          this.$scope.hessParcel = response.data[0];
          console.log("hessparcel: ", this.$scope.hessParcel);
          

          var znCode = _.filter(this.$scope.zn_codes, {
            zn_recid: response.data[0].zn_recid,
          });
          // console.log("znCode: ", znCode);

          //Populate zoning fields of modal window
          this.$scope.hessParcel.zn_code = znCode[0].zn_code;
          this.$scope.hessParcel.zn_description = znCode[0].zn_description;
          this.$scope.hessParcel.zn_max_height = znCode[0].zn_max_height;
          this.$scope.hessParcel.zn_min_dua = znCode[0].zn_min_dua;

          hess_category_desc = _.filter(this.$scope.hessCategoryLayers, {
            name: this.$scope.hessParcel.hess_color
          });
          // console.log('hess category desc: ', hess_category_desc);

        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  /**
   * @desc Opens appropriate update modal window based on parameters after clicking on More Info button in map popup
   * @param {object} parcel_id - ID of the parcel clicked on
   * @param (string) dbFactory - Database data factory
   * @param (string) $scope - Application level global scope
   */
  openSiteEditModalMoreInfo(parcel_id, $http, $scope, dbFactory) {
    //Open CRUD Modal
    if (parcel_id) {
      $("#siteSelectionModal").modal();

      dbFactory.getParcelDetail(parcel_id) //DB Factory function
        .then((response) => {
          var hess_category_desc;
          // console.log(response.data[0]);
          $scope.hessParcel = response.data[0];
          var znCode = _.filter($scope.zn_codes, {
            zn_recid: response.data[0].zn_recid,
          });
          // console.log("znCode: ", znCode);

          //Populate zoning fields of modal window
         if(znCode[0].zn_code){
          $scope.hessParcel.zn_code = znCode[0].zn_code;
         }
          $scope.hessParcel.zn_description = znCode[0].zn_description;
          $scope.hessParcel.zn_max_height = znCode[0].zn_max_height;
          $scope.hessParcel.zn_min_dua = znCode[0].zn_min_dua;

          hess_category_desc = _.filter($scope.hessCategoryLayers, {
            name: $scope.hessParcel.hess_color
          });
          // console.log('hess category desc: ', hess_category_desc);

        })
        .catch((err) => {
          console.log(err);
        });
    }
  }


  //Open filters modal
  openFiltersModal() {
    //Refresh multi select inputs in case data hasn't yet loaded
    // setTimeout(function () {
    //   $('.selectpicker').selectpicker('refresh'); // refresh the selectpicker with fetched courses
    // }, 1000);
    $('#newfiltersModal').modal();
  }


  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  zoomToSite(parcelId) {
    //Open CRUD Modal
    this.$scope.zoomSpinner = true;
    this.$http
      .get("/api/data/hess/parcelgeo/" + parcelId)
      .then((response) => {
        if (this.$scope.map.getSource("zoomParcelSource")) {
          this.$scope.map.removeLayer("zoomParcelLayer");
          this.$scope.map.removeSource("zoomParcelSource");
        }
        this.$scope.map.addSource("zoomParcelSource", {
          type: "geojson",
          data: {
            type: "Feature",
            geometry: response.data[0].geometry,
          },
        });
        this.$scope.map.addLayer({
          id: "zoomParcelLayer",
          type: "fill",
          source: "zoomParcelSource",
          layout: {},
          paint: {
            "fill-outline-color": "#00fffa",
            "fill-color": "white",
            "fill-opacity": 0.5,
          },
        });

        var bbox = turf.extent(response.data[0].geometry);
        this.$scope.map.fitBounds(bbox, {
          padding: -50,
        });
        this.$scope.zoomSpinner = false;
      })
      .catch((err) => {
        console.log(err);
      });
    // Resize map after modal div is fully rendered
  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  zoomToSiteFromParams(parcelId, $scope, $http, $location) {
    //Open CRUD Modal
    //    $scope.zoomSpinner = true;
    if (parcelId) {
      $http
        .get("/api/data/hess/parcelgeo/" + parcelId)
        .then((response) => {
          if ($scope.map.getSource("zoomParcelSource")) {
            $scope.map.removeLayer("zoomParcelLayer");
            $scope.map.removeSource("zoomParcelSource");
          }
          $scope.map.addSource("zoomParcelSource", {
            type: "geojson",
            data: {
              type: "Feature",
              geometry: response.data[0].geometry,
            },
          });
          $scope.map.addLayer({
            id: "zoomParcelLayer",
            type: "fill",
            source: "zoomParcelSource",
            layout: {},
            paint: {
              "fill-color": "#00fffa",
              "fill-opacity": 0.8,
            },
          });

          var bbox = turf.extent(response.data[0].geometry);
          $scope.map.fitBounds(bbox, {
            padding: -50,
          });
          $scope.zoomSpinner = false;
        })
        .catch((err) => {
          console.log(err);
        });
      // Resize map after modal div is fully rendered
      $location.search({});
    }
  }

  changeView(type) {
    if (type === "filters") {
      this.$scope.isResults = true;
      this.$scope.isFilters = false;
    } else if (type === "results") {
      this.$scope.isFilters = true;
      this.$scope.isResults = false;
    }
  }

  getMyList() {
    console.log('running get my list');
    this.$scope.listRecords = [];
    this.$http.get('/api/data/hess/parcel/list/' + this.$scope.city)
      .then(response => {
        // console.log(response.data);
        this.$scope.myListParcels = response.data;
        if (this.$scope.myListParcels.length > 0) {
          this.$scope.myListParcels.forEach(element => {
            this.$scope.listRecords.push(element.parcel_id);
          });
        }
        this.$scope.rowListCollection = response.data;

      })
      .catch(err => {
        console.log(err);
      });
  }

  closeSiteSelectionModal() {
    $("#siteSelectionModal").modal("hide");
  }

  closeFilterModal() {
    $("#newfiltersModal").modal("hide");
  }
// Admin 
  updateJurisdiction(){
    this.loadMap(this.$scope.city)
  }

  getJurisdictions(){
    this.$http.get('/api/data/admin/lookup/jurisdictions')
    .then(response => {
      console.log(this.$scope.user.role);
      // console.log(response.data)
      console.log(response.data[0].jurisdiction.split(','));
      if(this.$scope.user.role === 'consultant'){
        var jurisdictions = response.data[0].jurisdiction.split(',');
        var jurisdictionsArray = [];
        jurisdictions.forEach(element => {
          jurisdictionsArray.push({'jurisdiction': element});
        });
        this.$scope.jurisdictions = jurisdictionsArray;
      }
      else if(this.$scope.user.role === 'admin') {
        this.$scope.jurisdictions = response.data;
      }
      // console.log(this.$scope.jurisdictions);
    })
    .catch(err => {
      console.log(err);
    })
 }

//  Parcel Notes 
 addParcelNote(){
  var recid = uuid.v1();
   console.log(this.$scope.parcel_note);
   var data = {
     recid: recid,
     note: this.$scope.parcel_note,
     parcel_id: this.$scope.parcel_id
   };

   this.$http
      .post("/api/data/hess/parcel/note/add", data)
      .then((response) => {
        console.log(response.data);
       this.$scope.parcel_note = "";
       this.$scope.parcelNotes.unshift(response.data);
      })
      .catch((err) => {
        console.log(err);
       
      });
 }

 getParcelNotes(){
  this.$http
  .get("/api/data/hess/notes/" + this.$scope.parcel_id )
  .then((response) => {
   this.$scope.parcelNotes = response.data;
   console.log(this.$scope.parcelNotes);

  })
  .catch((err) => {
    console.log(err);
   
  });
 }
}

export default angular
  .module("hessApp.map", [uiRouter])
  .config(routes)
  .component("map", {
    template: require("./map.html"),
    controller: MapComponent,
    controllerAs: "mapCtrl",
  })
  .directive("pageSelect", function () {
    return {
      restrict: "E",
      template: '<input type="text" class="select-page" ng-model="inputPage" ng-change="selectPage(inputPage)">',
      link: function (scope, element, attrs) {
        scope.$watch("currentPage", function (c) {
          scope.inputPage = c;
        });
      },
    };
  })
  .directive("stResetSearch", function () {
    return {
      restrict: "EA",
      require: "^stTable",
      link: function (scope, element, attrs, ctrl) {
        return element.bind("click", function () {
          return scope.$apply(function () {
            var tableState;
            tableState = ctrl.tableState();
            tableState.search.predicateObject = {};
            tableState.pagination.start = 0;
            return ctrl.pipe();
          });
        });
      },
    };
  })
  .directive("stFilteredCollection", function () {
    return {
      require: "^stTable",
      link: function (scope, element, attr, ctrl) {
        scope.$watch(ctrl.getFilteredCollection, function (val) {
          scope.filteredCollection = val;
        });
      },
    };
  }).name;



// WEBPACK FOOTER //
// ./client/app/account/map/map.component.js